<ul class="tiles" role="list">
  <li class="tile tile--accent" data-tile="requiring-action">
    <span class="tile__label">Requiring action</span>
    <span class="tile__count" [class.tile__count--alert]="tiles?.requiringAction > 0">
      {{ tiles?.requiringAction ?? 0 }}
    </span>
  </li>
  <li class="tile" data-tile="active-applications">
    <span class="tile__label">Active applications</span>
    <span class="tile__count">{{ tiles?.activeApplications ?? 0 }}</span>
  </li>
  <li class="tile" data-tile="pending-activation">
    <span class="tile__label">Open – Pending Activation Draw</span>
    <span class="tile__value">
      <span class="tile__count">{{ tiles?.pendingActivation?.count ?? 0 }}</span>
      <span class="tile__amount">{{ tiles?.pendingActivation?.amount ?? 0 | compactCurrency }}</span>
    </span>
  </li>
  <li class="tile" data-tile="funded">
    <span class="tile__label">{{ fundedLabel }}</span>
    <span class="tile__value">
      <span class="tile__count">{{ tiles?.funded?.count ?? 0 }}</span>
      <span class="tile__amount">{{ tiles?.funded?.amount ?? 0 | compactCurrency }}</span>
    </span>
  </li>
</ul>
